import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'

export const SPACE_RECORD_FUNCTIONAL_METHODOLOGY = transformers.combine(
  graphql.transformers.IN.enumeration<
    ents.extra.space.Record.FunctionalUsage.Methodology,
    graphql.schema.SpaceRecordFunctionalMethodology
  >({
    [ents.extra.space.Record.FunctionalUsage.Methodology.Manual]:
      graphql.schema.SpaceRecordFunctionalMethodology.Manual,
    [ents.extra.space.Record.FunctionalUsage.Methodology.JointUse]:
      graphql.schema.SpaceRecordFunctionalMethodology.JointUse,
    [ents.extra.space.Record.FunctionalUsage.Methodology.ServiceCenter]:
      graphql.schema.SpaceRecordFunctionalMethodology.ServiceCenter,
    [ents.extra.space.Record.FunctionalUsage.Methodology.Vacant]:
      graphql.schema.SpaceRecordFunctionalMethodology.Vacant,
    [ents.extra.space.Record.FunctionalUsage.Methodology.Unassignable]:
      graphql.schema.SpaceRecordFunctionalMethodology.Unassignable,
    [ents.extra.space.Record.FunctionalUsage.Methodology.AutoLabBased]:
      graphql.schema.SpaceRecordFunctionalMethodology.AutoLabBased,
  }),
  graphql.transformers.OUT.enumeration<
    graphql.schema.SpaceRecordFunctionalMethodology,
    ents.extra.space.Record.FunctionalUsage.Methodology
  >({
    [graphql.schema.SpaceRecordFunctionalMethodology.Manual]:
      ents.extra.space.Record.FunctionalUsage.Methodology.Manual,
    [graphql.schema.SpaceRecordFunctionalMethodology.JointUse]:
      ents.extra.space.Record.FunctionalUsage.Methodology.JointUse,
    [graphql.schema.SpaceRecordFunctionalMethodology.ServiceCenter]:
      ents.extra.space.Record.FunctionalUsage.Methodology.ServiceCenter,
    [graphql.schema.SpaceRecordFunctionalMethodology.Vacant]:
      ents.extra.space.Record.FunctionalUsage.Methodology.Vacant,
    [graphql.schema.SpaceRecordFunctionalMethodology.Unassignable]:
      ents.extra.space.Record.FunctionalUsage.Methodology.Unassignable,
    [graphql.schema.SpaceRecordFunctionalMethodology.AutoLabBased]:
      ents.extra.space.Record.FunctionalUsage.Methodology.AutoLabBased,
  }),
)
